// services/api/yoloApi.js
import axiosInstance from "utils/axiosInstance";

const yoloApi = {
  /**
   * Fetches YOLO settings
   * @returns {Promise<Array>} A promise that resolves to an array of setting objects
   */
  getSettings: async () => {
    const response = await axiosInstance.get("/yolo/getall");
    return response.data || [];
  },

  /**
   * Updates a YOLO setting
   * @param {string} id - The ID of the setting to update
   * @param {Object} data - The updated setting data
   * @returns {Promise<Object>} A promise that resolves to the response data
   */
  updateSetting: async (id, data) => {
    const response = await axiosInstance.put(`/yolo/update/${id}`, data);
    return response.data;
  }
};

export default yoloApi;